import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeadlineTranslationPipe } from './deadlineTranslation.pipe';
import { ConditionTranslationPipe } from './condition-translation.pipe';
import { TruncatePipe } from './truncate.pipe';
import { ElementTypeTranslationPipe } from './element-type-translation.pipe';
import { ValueTypeTranslationPipe } from './value-type-translation.pipe';
import { UnitTranslationPipe } from './unit-translation.pipe';
import { RepairTaskStatusTranslationPipe } from '@shared/pipes/repairTaskStatusTranslation.pipe';
import { PluralizePipe } from './pluralize.pipe';
import { RichTextPipe } from '@shared/pipes/richText.pipe';
import { MaintenanceTimerTypePipe } from './maintenance-timer-type.pipe';
import { EmailTypeTranslationPipe } from '@shared/pipes/email-type-translation.pipe';
import { BuildingTypeTranslationPipe } from '@shared/pipes/building-type-translation.pipe';
import { BuildingClassTranslationPipe } from '@shared/pipes/building-class-translation.pipe';
import { EllipsisPipe } from '@shared/pipes/ellipsis.pipe';
import { RelativeDatePipe } from '@shared/pipes/relativeDate.pipe';
import { TenantTypePipe } from '@shared/pipes/tenant-type.pipe';
import { ContractorScopePipe } from '@shared/pipes/contractor-scope.pipe';
import { SensorUnitPipe } from '@shared/pipes/sensor-unit.pipe';
import { DimensionPipe } from '@shared/pipes/dimension.pipe';
import { LabelCategoryPipe } from '@shared/pipes/label-category.pipe';
import { SensorMetricKindPipe } from '@shared/pipes/sensor-metric-type.pipe';
import { SensorIntegrationTypePipe } from '@shared/pipes/sensor-integration-type.pipe';
import { SensorPurposePipe } from '@shared/pipes/sensor-purpose.pipe';
import { FacilityElementTranslationPipe } from '@shared/pipes/facility-element-translation.pipe';
import { ScanTypePipe } from '@shared/pipes/scan-type.pipe';
import { InsuranceCompanyTranslationPipe } from '@shared/pipes/insurance-company-translation.pipe';
import { InspectionTypePipe } from '@shared/pipes/inspection-type.pipe';
import { NormTypePipe } from '@shared/pipes/norm-type.pipe';
import { EmergencyContactTypeTranslationPipe } from '@shared/pipes/emergency-contact-type-translation.pipe';
import { HouseCareContactTypeTranslationPipe } from '@shared/pipes/house-care-contact-type-translation.pipe';


@NgModule({
  declarations: [
    DeadlineTranslationPipe,
    ConditionTranslationPipe,
    EmailTypeTranslationPipe,
    TruncatePipe,
    ElementTypeTranslationPipe,
    ValueTypeTranslationPipe,
    UnitTranslationPipe,
    RepairTaskStatusTranslationPipe,
    PluralizePipe,
    RichTextPipe,
    MaintenanceTimerTypePipe,
    BuildingTypeTranslationPipe,
    BuildingClassTranslationPipe,
    EllipsisPipe,
    RelativeDatePipe,
    TenantTypePipe,
    ContractorScopePipe,
    SensorUnitPipe,
    DimensionPipe,
    LabelCategoryPipe,
    SensorMetricKindPipe,
    SensorIntegrationTypePipe,
    SensorPurposePipe,
    FacilityElementTranslationPipe,
    ScanTypePipe,
    InsuranceCompanyTranslationPipe,
    NormTypePipe,
    InspectionTypePipe,
    EmergencyContactTypeTranslationPipe,
    HouseCareContactTypeTranslationPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    DeadlineTranslationPipe,
    ConditionTranslationPipe,
    EmailTypeTranslationPipe,
    TruncatePipe,
    ElementTypeTranslationPipe,
    ValueTypeTranslationPipe,
    UnitTranslationPipe,
    RepairTaskStatusTranslationPipe,
    PluralizePipe,
    RichTextPipe,
    MaintenanceTimerTypePipe,
    BuildingTypeTranslationPipe,
    BuildingClassTranslationPipe,
    EllipsisPipe,
    RelativeDatePipe,
    TenantTypePipe,
    ContractorScopePipe,
    SensorUnitPipe,
    DimensionPipe,
    LabelCategoryPipe,
    SensorMetricKindPipe,
    SensorIntegrationTypePipe,
    SensorPurposePipe,
    FacilityElementTranslationPipe,
    ScanTypePipe,
    InsuranceCompanyTranslationPipe,
    NormTypePipe,
    InspectionTypePipe,
    EmergencyContactTypeTranslationPipe,
    HouseCareContactTypeTranslationPipe,
  ],
  providers: [
    DeadlineTranslationPipe,
    RepairTaskStatusTranslationPipe,
    SensorUnitPipe,
  ],
})
export class PipesModule {
}
